import { Component } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';
import { url } from 'inspector';

@Component({
  selector: 'app-customer-reg',
  templateUrl: './customer-reg.component.html',
  styleUrls: ['./customer-reg.component.scss'],
})
export class CustomerRegComponent {

  loader:boolean=false;
  check: boolean = false;
  Cid;mob;
  VendoruserId;
  numCd = '+91';
  numb;
  hide;
  pass;
 id;
 url;
 itemTypeId;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
     public santinzer: DomSanitizer,
      public platform: Platform) { 
        document.addEventListener('keydown', function (e:any) {
          if (e.keyCode == 13) {
            sessionStorage.setItem('login','true')
          }
        });
      }

  ionViewWillEnter(){
    this.url = window.location.href; 
   this.id=sessionStorage.getItem('id')  
   this.itemTypeId=sessionStorage.getItem('itemTypeId')
   
  }

   
  login() {
    this.loader = true;
    let post = {
      "password": btoa(this.pass),
      "appId": "14"
    } 
    sessionStorage.removeItem("login");
    Object.assign(post,{"emailId":this.numCd+this.numb})
    this.auth.login(post).subscribe((res: any) => {     
        this.handler.loginRes(res);            
        window['mock'] = res;   
        this.handler.res('Welcome back user');
        this.auth.getUser();
        this.getCapability(res.userId); 
        this.auth.getConfig();
        
    },
      err => {
        this.handler.err(err)
        this.loader = false;
      })
  }

  getCapability(id) {  
      this.service.getCapability(id).subscribe((res: any) => {    
          let capabilities = res.capabilities.map(({ code }) => code);
          localStorage.setItem('capability', JSON.stringify(capabilities));
          localStorage.setItem('capabilityOrg', JSON.stringify(res.orgs)); 
          if(localStorage.getItem('capabilityOrg')) {
             this.loader = false;
             this.route();
            //  this.auth.getOrg();
          }    
          },
        err => {
          this.handler.err(err);
          this.loader = false;
        })
  
  }

  forgot(){
    this.router.navigate(['/vendorValidate']);
  }

  ionViewWillLeave(){
    this.numb = undefined;
    this.pass = undefined;
  }

  route(){ 
    if(this.url.includes('customer-reg')){
      sessionStorage.setItem('itemTypeId',this.itemTypeId)
      sessionStorage.setItem('dummyValue','true')
      this.router.navigate(['/subservice1']);    
    }
    if(this.url.includes('subs-cust-register')){
      this.router.navigate(['/subs-booking'])
    }
    if(this.url.includes('customer-login')){
      this.router.navigate(['purchase-items1/', this.id]);  
    }
   
  }

  
  ngDoCheck(){
    if(sessionStorage.getItem('login')=='true'){
      this.login()
    }
  }

  signIn(){
    this.router.navigate(['/customerProfile'])
  }


}
